import React from 'react';

const PowerUsersReports = () => {
  const metabaseUrl = "https://dev-metabase.thedigitalgroup.com/public/dashboard/1e90c7ea-1443-4b08-a11f-1d9b02efdf90";

  return (
    <div style={{ width: '100%', height: '100vh', padding: '1rem' }}>
      <iframe
        src={metabaseUrl}
        title="Power Users Dashboard"
        style={{
          width: '100%',
          height: '90vh',
          border: 'none',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
        allowFullScreen
      />
    </div>
  );
};

export default PowerUsersReports;
